<template>
  <div class="app">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
      <el-tab-pane label="知识库" name="kb" style="height: 100%;">
        <bd-knowledge></bd-knowledge>
      </el-tab-pane>
      <!-- <el-tab-pane label="附件" name="attachment" style="height: 100%;">
        <bd-attachment></bd-attachment>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="设置" name="settings" style="height: 100%;">
        <bd-settings></bd-settings>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import BdKnowledge from '@/components/dashboard/main/kb/BdKnowledge'
// import BdAttachment from '@/components/dashboard/main/kb/BdAttachment'
// import BdSettings from '@/components/dashboard/main/kb/BdSettings'

export default {
  name: 'bd-kb',
  components: { BdKnowledge}, // BdAttachment, , BdSettings 
  data () {
    return {
      activeName: 'kb',
      show: false,
    }
  },
  computed: {
    // ...mapGetters([ 'showAuthority' ]),
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  }
}
</script>

<style scope>
.el-tabs__header {
  margin: 0px !important;
  background-color: #f2f2f2 !important;
}
.el-tabs__content {
  padding-top: 0px !important;
}
</style>
